import { YANDEX_METRIKA_ID } from "./yandexMetrika";
import { isAnalyticsAllowed } from "../utils/cookieConsent";

let loadPromise = null;

/**
 * Подключает Яндекс.Метрику только после согласия на аналитические cookies.
 */
export function ensureYandexMetrikaLoaded() {
  if (typeof window === "undefined") return Promise.resolve(false);
  if (!isAnalyticsAllowed()) return Promise.resolve(false);
  if (typeof window.ym === "function" && window.__baysportMetrikaInited) {
    return Promise.resolve(true);
  }
  if (loadPromise) return loadPromise;

  loadPromise = new Promise((resolve) => {
    const finish = () => {
      try {
        if (typeof window.ym === "function" && !window.__baysportMetrikaInited) {
          window.dataLayer = window.dataLayer || [];
          window.ym(YANDEX_METRIKA_ID, "init", {
            ssr: true,
            webvisor: true,
            clickmap: true,
            ecommerce: "dataLayer",
            referrer: document.referrer,
            url: window.location.href,
            accurateTrackBounce: true,
            trackLinks: true,
          });
          window.__baysportMetrikaInited = true;
        }
        resolve(typeof window.ym === "function");
      } catch {
        resolve(false);
      }
    };

    if (typeof window.ym === "function") {
      finish();
      return;
    }

    (function (m, e, t, r, i, k, a) {
      m[i] =
        m[i] ||
        function () {
          (m[i].a = m[i].a || []).push(arguments);
        };
      m[i].l = 1 * new Date();
      for (let j = 0; j < document.scripts.length; j += 1) {
        if (document.scripts[j].src === r) {
          finish();
          return;
        }
      }
      k = e.createElement(t);
      a = e.getElementsByTagName(t)[0];
      k.async = 1;
      k.src = r;
      k.onload = finish;
      k.onerror = () => resolve(false);
      a.parentNode.insertBefore(k, a);
    })(
      window,
      document,
      "script",
      `https://mc.yandex.ru/metrika/tag.js?id=${YANDEX_METRIKA_ID}`,
      "ym",
    );
  });

  return loadPromise;
}
